import type { InterventionTemplateDuplicateFormProps } from "./intervention-template-duplicate-form.type";

import { ModelDuplicateForm } from "@/modules/model-duplicate";

import { useInterventionTemplateDuplicateForm } from "./intervention-template-duplicate-form.hook";

const InterventionTemplateDuplicateForm = (
  props: InterventionTemplateDuplicateFormProps
) => {
  const {
    form,
    formId,
    initialValues,
    onFormSubmit,
    isPending,
    validation,
    validationErrors,
  } = useInterventionTemplateDuplicateForm(props);

  return (
    <ModelDuplicateForm
      form={form}
      formId={formId}
      initialValues={initialValues}
      onFormSubmit={onFormSubmit}
      loading={isPending}
      validation={validation}
      validationErrors={validationErrors}
    />
  );
};

export default InterventionTemplateDuplicateForm;
